// extracted by mini-css-extract-plugin
module.exports = {"CallOuts":"CallOuts_CallOuts__1rsS7","Overlay":"CallOuts_Overlay__3LBWm","Content":"CallOuts_Content__13ERy","Row":"CallOuts_Row__1_O7M","Column":"CallOuts_Column__3Gh4V"};